import Avatar, { AvatarProps } from "@material-ui/core/Avatar";
import { makeStyles, Theme } from "@material-ui/core/styles";
import PersonIcon from "@material-ui/icons/Person";
import { RefObject } from "react";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import { theme } from "../../../zApps/Layout";
import { UserBase } from "../types";

interface Props extends AvatarProps {
    user: UserBase | undefined;
    colorNumber: number | "noColor";
    size: number;
    icon300?: boolean;
    avatarRef?: RefObject<HTMLDivElement>;
}

export function UserAvatar({
    user,
    colorNumber,
    size,
    className,
    icon300,
    avatarRef,
    ...rest
}: Props) {
    const c = useStyles({ size, colorNumber });

    if (user?.avatarPath) {
        return (
            <Avatar
                key="avatar"
                className={spaceBetween(c.imgAvatar, className)}
                ref={avatarRef}
                {...rest}
            >
                <img
                    src={
                        icon300
                            ? user.avatarPath.replace("150_150", "width300")
                            : user.avatarPath
                    }
                    className={c.img}
                    alt={user.name}
                    title={user.name}
                />
            </Avatar>
        );
    }
    return (
        <Avatar
            key="avatar"
            className={spaceBetween(c.iconAvatar, className)}
            ref={avatarRef}
            {...rest}
        >
            <PersonIcon className={c.icon} />
        </Avatar>
    );
}

const colors = [
    "#DC7633",
    theme.palette.primary.light,
    theme.palette.success.main,
    theme.palette.secondary.light,
    "#8E44AD",
    "#EC7063",
    "#34495E",
    "#5499C7",
    "#D4AC0D",
];

const useStyles = makeStyles<
    Theme,
    { size: number; colorNumber: number | "noColor" }
>(theme => ({
    imgAvatar: ({ size }) => ({
        width: size,
        height: size,
        boxShadow: `0 0 3px ${theme.palette.grey[400]}`,
    }),
    img: ({ size }) => ({
        objectFit: "cover",
        objectPosition: "50% 50%",
        width: size,
        height: size,
    }),
    iconAvatar: ({ size, colorNumber }) => ({
        width: size,
        height: size,
        backgroundColor:
            colorNumber === "noColor"
                ? undefined
                : colors[colorNumber % colors.length],
    }),
    icon: ({ size }) => ({
        width: size * 0.8,
        height: size * 0.8,
    }),
}));
